import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { StatusPill } from '../../ui';
import ExportSectionRow from './ExportSectionRow';
import { boardFilterLabels } from './packageExportUtils';

const OptionCheckbox = ({ label, checked, onChange, disabled }) => {
  const { ft } = useTheme().palette;
  return (
    <FormControlLabel
      label={label}
      disabled={disabled}
      control={
        <Checkbox
          size="small"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          sx={{ p: 0, '& .MuiSvgIcon-root': { fontSize: 22 } }}
        />
      }
      sx={{
        m: 0,
        gap: '10px',
        minHeight: 32,
        '& .MuiFormControlLabel-label': { fontSize: 14, color: ft.neutrals.textPrimary },
        '& .MuiFormControlLabel-label.Mui-disabled': { color: ft.neutrals.textDisabled },
      }}
    />
  );
};

/**
 * Packages section: Apply board filters (with the active filters as pills),
 * Include general conditions, Include change orders (plan §4.5).
 */
const ExportPackageOptionsSection = ({ settings, boardFilters, onChange, disabled }) => {
  const { ft } = useTheme().palette;
  const pills = boardFilterLabels(boardFilters);
  const noBoardFilters = pills.length === 0;

  return (
    <ExportSectionRow label="Packages" labelOffset={7}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', minHeight: 32 }}>
          <OptionCheckbox
            label="Apply board filters"
            checked={settings.applyBoardFilters && !noBoardFilters}
            onChange={(applyBoardFilters) => onChange({ applyBoardFilters })}
            disabled={disabled || noBoardFilters}
          />
          {noBoardFilters ? (
            <Typography variant="caption" sx={{ color: ft.neutrals.textSecondary }}>
              No board filters are active
            </Typography>
          ) : (
            pills.map((label) => <StatusPill key={label} tone="neutral" label={label} />)
          )}
        </Box>
        {/* The board's Name / Description search fields never apply (plan §1.3). */}
        <Typography variant="caption" component="p" sx={{ color: ft.neutrals.textSecondary, pl: '28px' }}>
          The board's Name and Description filters are not applied.
        </Typography>
        <OptionCheckbox
          label="Include general conditions packages"
          checked={settings.includeGeneralConditions}
          onChange={(includeGeneralConditions) => onChange({ includeGeneralConditions })}
          disabled={disabled}
        />
        <OptionCheckbox
          label="Include change order packages"
          checked={settings.includeChangeOrders}
          onChange={(includeChangeOrders) => onChange({ includeChangeOrders })}
          disabled={disabled}
        />
        <Typography variant="caption" component="p" sx={{ color: ft.neutrals.textSecondary, pl: '28px' }}>
          Archived packages are always included. Deleted packages are never included.
        </Typography>
      </Box>
    </ExportSectionRow>
  );
};

export default ExportPackageOptionsSection;
